import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type {
  FilesystemState,
  UiSnapshotFile,
  UiSnapshotSummary,
} from "./types";

export const useFilesystemStore = create<FilesystemState>()(
  devtools(
    (set) => ({
      // Collections
      snapshots: [],
      filesBySnapshotId: {},
      stagedFiles: [],

      // Mutators
      setSnapshots: (snapshots: UiSnapshotSummary[]) => set({ snapshots }),

      upsertSnapshotFiles: (snapshotId: string, files: UiSnapshotFile[]) =>
        set((state) => ({
          filesBySnapshotId: {
            ...state.filesBySnapshotId,
            [snapshotId]: files,
          },
        })),

      setStagedFiles: (files: UiSnapshotFile[]) =>
        set({
          stagedFiles: files.map((f) => ({
            ...f,
            status: f.status ?? "completed",
          })),
        }),

      upsertStagedFile: (file: UiSnapshotFile) =>
        set((state) => {
          const fileWithStatus = {
            ...file,
            status: file.status ?? "completed",
          };
          const existingIndex = state.stagedFiles.findIndex(
            (f) => f.path === file.path,
          );

          if (existingIndex >= 0) {
            // Update existing file
            const updatedFiles = [...state.stagedFiles];
            updatedFiles[existingIndex] = fileWithStatus;
            return { stagedFiles: updatedFiles };
          }

          // Add new file
          return { stagedFiles: [...state.stagedFiles, fileWithStatus] };
        }),

      clearFilesystem: () =>
        set({
          snapshots: [],
          filesBySnapshotId: {},
          stagedFiles: [],
        }),
    }),
    { name: "filesystem-store" },
  ),
);
